if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();

      this.querySelector('.slider-button--prev')?.addEventListener('click', () => {
        const current = this.querySelector('.active[data-media-id]');
        current.classList.remove('active');
        if(current.previousElementSibling) {
          current.previousElementSibling.classList.add('active')
        } else {
          this.querySelector('[data-media-id]:last-child').classList.add('active');
        }
      });

      this.querySelector('.slider-button--next')?.addEventListener('click', () => {
        const current = this.querySelector('.active[data-media-id]');
        current.classList.remove('active');
        if(current.nextElementSibling) {
          current.nextElementSibling.classList.add('active')
        } else {
          this.querySelector('[data-media-id]:first-child').classList.add('active');
        }
      });
    }

    hide() {
      this.querySelector('.product-media-modal__toggle')?.addEventListener('click', () => {
        super.hide();
      })
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      // activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube')) {
        activeMedia.loadContent();
      }
    }
  });
}
